module.exports = __webpack_public_path__ + "static/img/anquan.cd2dba9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/DiscountAgentInvite/PC/anquan.png
// module id = T52t
// module chunks = 70